import { Injectable } from "@angular/core";
import { apiconstants } from "../constants/api.constant";
import { BehaviorSubject, Observable, map, retry } from "rxjs";
import { IResponse } from "../models/response";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class CutSheetService {
  public isJsnAddedToRooms = new BehaviorSubject<any>("");
  public accountDetails = new BehaviorSubject<any>("");

  constructor(private _http: HttpClient) { }

  jsnlistbydepartmentid(departmentId: any) {
    return this._http
      .get(apiconstants.API_GET_JSN_LIST_BY_DEPARTMENT_ID + `/${departmentId}`)
      .pipe(
        // API_JSN
        map((response: IResponse) => {
          return response.data;
        })
      );
  }
  getJSN(body) {
    return this._http.post(apiconstants.API_JSN_LIST_PRINT_CUTSHEET, body).pipe(
      // API_JSN
      map((response: IResponse) => {
        return response.data;
      })
    );
  }
  getJsnByNameType(params?) {
    return this._http
      .get(apiconstants.API_JSN_BY_PROJECT_NAME_TYPE, { params })
      .pipe(
        // API_JSN
        map((response: IResponse) => {
          return response.data;
        })
      );
  }
  getAiIssue(body) {
    return this._http.post(apiconstants.API_GET_AI_ISSUE, body);
  }
  getAllCutsheetsByProjectId(projectId: string): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_ALL_CUT_SHEETS + `/${projectId}`)
      .pipe(
        // API_JSN
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getAllManufacturers() {
    return this._http.get(apiconstants.API_GET_ALL_MANUFACTURER).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getAllJSN(params?): Observable<any> {
    return this._http.get(apiconstants.API_JSN, { params }).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getProjectJSNList(projectId): Observable<any> {
    return this._http
      .get(apiconstants.API_PROJECT_JSN_LIST + "/" + projectId)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getJSNList(projectId, obj?): Observable<any> {
    return this._http
      .get(apiconstants.API_JSN_LIST + "/" + projectId, { params: obj })
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getMasterJSNList(params): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_MASTER_JSN_LIST, { params })
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getMasterCloudJSNList(params): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_MASTER_CLOUD_JSN_LIST, { params })
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getAllJSNDetails(): Observable<any> {
    return this._http.get(apiconstants.API_JSN).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getCutsheetDetailByCutsheetId(cutsheetId: string, showLoader?: boolean) {
    return this._http.get(apiconstants.API_JSN + `/${cutsheetId}`, { headers: { loader: showLoader ? "true" : "false" } }).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  deleteCutsheetByCutsheetId(cutsheetId: string) {
    return this._http.delete(apiconstants.API_JSN + `/${cutsheetId}`).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }
  printCutsheet(body: any) {
    return this._http
      .post(apiconstants.API_PRINT_CUTSHEET, body, {
        headers: { loader: "false" },
      })
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getManufacturerContactByAccountId(accountId: string): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_MANUFACTURER_CONTACT_DETAILS + `/${accountId}`)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  getManufacturerList(cutsheetname: string): Observable<any> {
    return this._http
      .get(apiconstants.API_MANUFACTURER + `/${cutsheetname}`)
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  getUtilityItemsList(projecttype: any): Observable<any> {
    return this._http
      .get(apiconstants.API_GET_UTILITY_LIST, {
        params: {
          projecttype,
        },
      })
      .pipe(
        map((response: IResponse) => {
          return response;
        })
      );
  }

  getAllManufacturerList(params?): Observable<any> {
    let url = apiconstants.API_GET_ALL_MANUFACTURER;
    if (params) {
      url = url + "?search=" + `${params}`;
    }
    return this._http.get(url).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getCloudLibraryProjectInfo(): Observable<IResponse> {
    return this._http.get(apiconstants.API_CLIB_PROJECT).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }
  getMilStdProjectInfo(): Observable<IResponse> {
    return this._http.get(apiconstants.API_MILSTD_PROJECT).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  saveJsn(cutsheetData: any): Observable<any> {
    let entries = Object.fromEntries(cutsheetData.entries())
    if (entries['old_jsno'] || entries['old_jsnother']) {
      return this.saveJsnWithName(cutsheetData)
    }

    return this._http.post(apiconstants.API_JSN, cutsheetData).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }
  saveJsnWithName(cutsheetData: any): Observable<any> {
    return this._http.post(apiconstants.API_JSN_WITH_NAME, cutsheetData).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }
  overrideJsn(cutsheetData: any): Observable<any> {
    return this._http.post(apiconstants.API_JSN_REPLACE_TARGET, cutsheetData).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  cutsheetChange(payload: any) {
    return this._http
      .post(apiconstants.API_CHECKJSNEXISTINGAPPROVAL, payload)
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }
  getAllExistingApproval(cutsheetId: string) {
    return this._http
      .post(apiconstants.API_GETALLEXISTINGAPPROVALJSN + "/" + cutsheetId, {})
      .pipe(
        map((response: IResponse) => {
          return response.data;
        })
      );
  }

  saveCloudLibJsn(cutsheetData: any): Observable<any> {
    return this._http.post(apiconstants.API_CLIB_JSN, cutsheetData).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  addCloudJSNtoProject(payload: any) {
    return this._http.post(apiconstants.API_POST_CLIB_JSN, payload).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  checkIfJsnExists(payload: any) {
    return this._http.post(apiconstants.API_POST_DUP_JSN_CHECK, payload).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  deleteImage(payload: any): Observable<any> {
    return this._http.post(apiconstants.API_DELETE_IMAGE, payload).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  addJSNToMultipleRooms(payload: any): Observable<any> {
    return this._http
      .post(apiconstants.API_MULTIPLE_JSN, payload, { observe: "response" })
      .pipe();
  }

  getAllInstallationArea() {
    return this._http.get(apiconstants.API_GET_INSTALLATION_AREA).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getAllInstallBy() {
    return this._http.get(apiconstants.API_GET_INSTALL_BY).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getAllSubtrades() {
    return this._http.get(apiconstants.API_GET_SUBTRADES).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getAllUtilities() {
    return this._http.get(apiconstants.API_GET_UTILITY_LENGTH).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  updateDealerInfo(dalerId: string, payload: any): Observable<any> {
    return this._http
      .post(apiconstants.API_PUT_DEALER_INFO + "/" + dalerId, payload)
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }

  createAccount(payload: any): Observable<any> {
    return this._http.post(apiconstants.API_PUT_DEALER_INFO, payload).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  getAllDrainSize() {
    return this._http.get(apiconstants.API_GET_ALL_DRAIN_SIZE).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getJsnDepartments(jsnId: string): Observable<any> {
    return this._http.get(`${apiconstants.API_JSN_DEPARTMENT}/${jsnId}`).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  addJsnToDepartment(payload: { jsnid: string; DepartmentIds: { id: string }[] }): Observable<any> {
    return this._http.post(apiconstants.API_JSN_DEPARTMENT, payload).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }
}
